import { TextSnippet } from "./TextSnippet";
export class LinebreakSnippet extends TextSnippet {
    constructor(id = null) {
        super(id);
        this.text = "\n";
    }
    copy() {
        return new LinebreakSnippet(this.id);
    }
}
